import React from 'react';
import Link from 'next/link';
import styles from './styles';
import TagsList from '../TagsList';

const PostCard = ({ post, topicUid, discussionTitle, handleSelectDiscussion, discussion }) => {
  return (
    <>
      <Link href={`/knowledge-hub/${topicUid}/${post.uid}`} passHref>
        <a onClick={() => handleSelectDiscussion(discussion)} style={{ textDecoration: 'none' }}>
          <div className="post" style={{ cursor: 'pointer' }}>
            <div className="post-content">
              <h3 className="post-title">{post.data.title}</h3>
              <div className="post-tags">
                <TagsList post={post} />
                <span className="post-link">Read more {' >'}</span>
              </div>
            </div>
          </div>
        </a>
      </Link>
      <style jsx>{styles}</style>
    </>
  );
};

export default PostCard;
